import ProfileLayout from '../../../../commons/ProfileLayout/ProfileLayout';
import ProfileHeader from '../ProfileHeader/ProfileHeader';
import ProfilePasswordForm from './ProfilePasswordForm/ProfilePasswordForm';

export default () => {
  return (
    <ProfileLayout>
      <ProfileHeader />
      <section className="profile__main-row">
        <ProfilePasswordForm />
      </section>
    </ProfileLayout>
  );
};
